export enum NotificationTypes {
  SUCCESS,
  ERROR,
}

export enum CommonModals {
  LOGIN,
  PAYMENT,
  STATUS_MENU,
  CHAT_MENU,
  FILTER,
  SORT,
  LOADER,
  CITY_SELECT,
}

export enum BannerVariant {
  BASE,
  SPLIT,
  EXPANDED,
  COMPACT,
  HERO,
}

export enum EmailStage {
  EMAIL_INPUT,
  CODE_INPUT,
  DONE,
  ERROR,
}

export enum AuthPrimary {
  TELEGRAM,
  EMAIL,
  MAX,
}

export enum LegalEntityType {
  INDIVIDUAL,
  LLC,
  JSC,
  SOLE,
  OTHER,
  UNSET = -1,
}

export enum ClusterTypes {
  FOOD,
  FLOWERS,
  DIY,
  CLOTHES,
  FURNITURE,
  DOORS,
  DEALER,
  OIL,
  COSMETICS,
  HOTEL,
  BEAUTY_SALON,
  MEDICINE,
  PHOTO_STUDIO,
  AUTO_PARTS,
}

export enum StoreType {
  FOOD_DARK_STORE,
  GOODS_DARK_STORE,
  RESTAURANT,
  FAST_FOOD,
  FLOWERS_SHOP,
}

export enum ApplicationStatus {
  NEW = 1,
  PENDING = 2,
  ACCEPTED = 3,
  REJECTED = 4,
  VACANCY_CLOSED = 5,
  REDIRECTED = 6,
}

export enum Unit {
  NOT_SELECTED = -1,
  GRAM,
  KILOGRAM,
  TON,
  MILLILITER,
  LITER,
  PIECE,
  CENTIMETER,
  METER,
  MINUTE,
  HOUR,
  DAY,
  MONTH,
  YEAR,
  PORTION,
  EMPTY,
}

export enum FieldType {
  NOT_SELECTED = -1,
  INPUT,
  SELECT,
  MULTISELECT,
  CHECKBOX,
}

export enum ValueType {
  NOT_SELECTED = -1,
  STRING,
  NUMBER,
  BOOLEAN,
  DATE,
}

export enum OrderStatus {
  NEW,
  PREPARING,
  DELIVERING,
  DELIVERED,
  PICKED_UP,
  CANCELLED,
  READY,
}

export enum TaskStatus {
  PENDING = 0,
  TAKEN = 1,
  IN_PROGRESS = 2,
  ARRIVED = 3,
  DELIVERED = 4,
  CANCELLED = 5,
}

export enum PaymentMethod {
  UNSET = -1,
  CARD_ON_DELIVERY,
  CASH_ON_DELIVERY,
  ONLINE,
}

export enum PaymentStatus {
  PENDING,
  PAID,
  FAILED,
  REFUNDED,
}
export enum DeliveryType {
  UNSET = -1,
  DELIVERY,
  PICKUP,
}

export enum ComplexOrderStatus {
  DRAFT = 0,
  SENT_TO_MANAGER = 1,
  IN_PROGRESS = 2,
  APPROVED = 3,
  CONVERTED = 4,
  ARCHIVED = 5,
}

export enum DeliveryStatus {
  CREATED = "CREATED",
  IN_TRANSIT = "IN_TRANSIT",
  READY_FOR_PICKUP = "READY_FOR_PICKUP",
  DELIVERED = "DELIVERED",
  NOT_DELIVERED = "NOT_DELIVERED",
  RETURNED = "RETURNED",
  CANCELLED = "CANCELLED",
}

export enum TaskType {
  DELIVERY = 0,
  SALE = 1,
  SERVICE = 2,
}

export enum DeliveryService {
  CDEK = "cdek",
  DELLIN = "dellin",
  PEK = "pek",
  CUSTOM = "custom",
}